import './App.css';
import CombineRouting from './Routes/CombineRouting';

function App() {
  return (
    <div className="App">
      <CombineRouting/>
    </div>
  )
}

export default App;
